/**
 * 回傳 Home Page 與 Solutions Page 按鈕格式化後的網址
 * @param url: String
 * @returns String
 */

export function useFormatUrl() {
  const { $i18n } = useNuxtApp();
  const { locale } = $i18n;
  const router = useRouter();

  // 回傳符合格式的網址

  const provideFormatUrl = (url: string | undefined): string => {
    // 網址無效，回傳 'javascript:;'
    if (!url || url === 'javascript:;') {
      return 'javascript:;';
    }

    // 網址為絕對路徑（http開頭），回傳原網址
    if (url.indexOf('http') === 0) {
      return url;
    }

    // 網址為相對路徑（locale開頭），回傳原網址
    if (url.indexOf(`/${locale.value}/marketplace`) === 0) {
      return url;
    }

    // 網址為相對路徑（非locale開頭），回傳加上locale後的網址
    return `/${locale.value}/marketplace${url}`;
  };

  // 根據網址格式執行跳轉

  const processLink = (url: string): void => {
    if (url.indexOf('http') === 0) {
      window.open(url, '_blank');
    } else {
      router.push(url);
    }
  };

  return { provideFormatUrl, processLink };
}
